<template>
    <!--弹窗-->
    <el-dialog
        width="640px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
        append-to-body
    >
        <el-input v-model="asinInfo.project_budget_asin"></el-input>

        <span slot="footer" class="dialog-footer">

            <el-button @click="handleClose" size="mini" type="danger" style="margin-right: 10px">关 闭</el-button>
             <el-button size="mini" type="primary" @click="submitForm()" :loading="loading">修 改</el-button>

          </span>

    </el-dialog>
</template>
<script>

import * as api from '@/api/Product/Product'

export default {
    data() {
        return {
            visible: false,
            loading: false,
            asinInfo: {},
            title: ''
        }
    },
    methods: {
        submitForm() {
            this.loading = true
            api.seed_word_asin_list_update_field({
                id: this.asinInfo.id,
                project_budget_asin: this.asinInfo.project_budget_asin
            }).then(res => {
                if (res.code === 0) {
                    this.$message({message: '修改成功', type: 'success'})
                    this.handleClose(false)
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).catch(() => {
                this.$message({type: 'error', message: '网络出现问题，请刷新页面！'})
            }).finally(() => {
                this.loading = false
            })
        },
        openModal(title, data) {
            this.title = title
            this.asinInfo = JSON.parse(JSON.stringify(data))
            this.visible = true
        },

        // 关闭弹窗
        handleClose(flag) {
            this.visible = false
            this.$emit('close-callback', flag !== false)
        }
    }
}
</script>
<style type="text/scss" lang="scss">
.wrapBox {
    width: 600px;
    margin-top: 10px;

    .bottomBox {
        margin-top: 17px;
        display: flex;
        justify-content: center;
    }
}

.download {
    display: flex;
    justify-content: center;
}

.top {
    margin: 0px auto 20px;
    width: 60%;
    display: flex;
    justify-content: space-between;
}
</style>

